import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

import queries from '../../../utils/queries'

const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Empresa...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleConNivel1 = props => {
  return (
    <option style={props.styles.input} dato1={props.elemento.email?props.elemento.email:""} dato2={props.elemento.telefono?props.elemento.telefono:""}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaCon = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleConNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista1" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Contacto...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
const ListaPri = ({styles, handleChange}) => {
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="prioridad" id="miLista2" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar prioridad...</option>        
        <option>Normal</option>
        <option>Alta</option>
      </select>
    </div>
  )
};


const DetallePl = ({elemento, handleClickGesEgr, argsDocum}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>

      <td className='center aligned' style={{padding: '0.2em'}}>
        <div className="ui mini vertical yellow animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
          <div className="hidden content" onClick={(ev)=>handleClickGesEgr(ev, elemento, "Agregar", argsDocum)}>Agregar</div>
          <div className="visible content">
            <i className="large thumbs up icon" style={{padding: '0.2em'}} onClick={(ev)=>handleClickGesEgr(ev, elemento, "Agregar")}></i>
          </div>
        </div>
      </td>
    </tr>
  )
};

const ListaPl = ({list, handleClickGesEgr, argsDocum}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickGesEgr={handleClickGesEgr} argsDocum={argsDocum}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetalleIL = ({elemento, handleClickGesEgr}) => {
  // let color=elemento.color
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
      
      <td className='center aligned' style={{padding: '0.2em'}}>
        <div className="ui mini vertical red animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
          <div className="hidden content" onClick={(ev)=>handleClickGesEgr(ev, elemento, "Quitar")}>Quitar</div>
          <div className="visible content">
            <i className="large thumbs down icon" style={{padding: '0.2em'}} onClick={(ev)=>handleClickGesEgr(ev, elemento, "Quitar")}></i>
          </div>
        </div>
      </td>
    </tr>
  )
};

const ListaIL = ({list, handleClickGesEgr}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleIL elemento={elemento} handleClickGesEgr={handleClickGesEgr}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos informe

class LabInflab2 extends React.Component {
  state={argsDocum: {descrEmpresa: "Seleccionar Empresa...", nombreUsuario: "Seleccionar Contacto...", 
         email: "", telefono: ""}, list: [], argsBuscInf: {},
          permiteUpdate: true, confirmaAct: false, open: false, argsBuscEstruct: {},
          argsQuery: `{"$unwind": "$secciones"},
            {"$unwind": "$secciones.equipos"},
            {"$unwind": "$secciones.equipos.componentes"},
            {"$unwind": "$secciones.equipos.componentes.mecanismos"},
            {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
              descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
              descrEquipo: '$secciones.equipos.descrEquipo', descrPrograma: '$secciones.equipos.descrPrograma',
              codComponente: '$secciones.equipos.componentes.codComponente',
              descrComponente: '$secciones.equipos.componentes.descrComponente',
              codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
              descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
              descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
              descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
              descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
              tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
              tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
              descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado',
              tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
              abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
              cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
              descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
              abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
              enInfLabNuevo: '$secciones.equipos.componentes.mecanismos.enInfLabNuevo'}}`,
          argsQuery1: `{"$unwind": "$pruebaslab"},
              {$project: {_id: '$pruebaslab.fechaCreate', tipoPrueba: 1, descrPrueba: 1, validacion: 1,
                  descrAplicacion: '$pruebaslab.descrAplicacion', 
                  valor1Alarma: '$pruebaslab.valor1Alarma', 
                  valor2Alarma: '$pruebaslab.valor2Alarma', 
                  valor3Alarma: '$pruebaslab.valor3Alarma', 
                  valor1Corte: '$pruebaslab.valor1Corte', 
                  valor2Corte: '$pruebaslab.valor2Corte', 
                  valor3Corte: '$pruebaslab.valor3Corte',
                  fechaCreate: '$pruebaslab.fechaCreate'}},
              {$sort: {tipoPrueba: 1, descrPrueba: 1, descrAplicacion: 1}}`
        }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      console.log(args)
      const {data} = await operacionCRUD({
        variables: args
      });
      console.log(args)

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        console.log(args)
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    console.log(codigo)
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      console.log(crudColecc[i], argsCrud[i], i)
      await this.crudBD(crudColecc[i], argsCrud[i], i)
      console.log(codigo)
    }
  }

  handleChange = async (ev) => {
    const argsDocum = this.state.argsDocum
    let argsBuscar=""
    if(ev.target.name==="descrEmpresa" || ev.target.name==="nombreUsuario" || ev.target.name==="prioridad"){
        argsDocum[ev.target.name] = ev.target.value
      if(ev.target.name==="descrEmpresa"){
        argsBuscar += `'descrEmpresa': '${ev.target.value}'`
      }else{
        argsBuscar += `'descrEmpresa': '${argsDocum.descrEmpresa}'`
      }
      if(ev.target.name==="nombreUsuario"){      
        var miLista = document.getElementById("miLista1");
        if(miLista.options[miLista.selectedIndex].text!=="Seleccionar Contacto..."){
          argsDocum['nombreUsuario'] = miLista.options[miLista.selectedIndex].text
          argsDocum['email'] = miLista.options[miLista.selectedIndex].attributes[0].value
          argsDocum['telefono'] = miLista.options[miLista.selectedIndex].attributes[1].value
        }
      }
      if(this.props.argsBuscInf.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
      }
      if(this.props.argsBuscInf.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
      }
      if(this.props.argsBuscInf.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
      }
      if(this.props.argsBuscInf.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
      }
      if(this.props.argsBuscInf.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
      }
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'tipoLub': 'Aceite', 'enInfLabNuevo': false, ${argsBuscar}}}]`}
      console.log(argsBuscarPl)
      let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
      let list = []
      if(data.allPlantaRtes && data.allPlantaRtes.length>0){
        list = await data.allPlantaRtes
        this.setState({list});
      }
    }
    this.setState({argsDocum});
  }

  handleClickGesEgr = async (ev, elemento, accion, args)=>{
    // console.log(accion)
    // console.log(elemento)
    document.body.style.cursor = 'wait'

    if(accion==="Agregar"){
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = await response.data.fecha

      let actColecc = [], creaColecc = []

      let argsUpd = {
        "descrEmpresa": elemento.descrEmpresa,
        "descrPlanta": elemento.descrPlanta,
        "tipoAct": "EditarInflab",
        "descrSeccion": elemento.descrSeccion,
        "descrEquipo": elemento.descrEquipo,
        "descrComponente": elemento.descrComponente,
        "descrMecanismo": elemento.descrMecanismo,
        "enInfLabNuevo": true,
      }
      actColecc.push(argsUpd)

      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${elemento.descrEmpresa}'`
      argsBuscar += `, 'descrPlanta': '${elemento.descrPlanta}'`
      argsBuscar += `, 'descrSeccion': '${elemento.descrSeccion}'`
      argsBuscar += `, 'descrEquipo': '${elemento.descrEquipo}'`
      argsBuscar += `, 'descrComponente': '${elemento.descrComponente}'`
      argsBuscar += `, 'descrMecanismo': '${elemento.descrMecanismo}'`

      let argsBuscarPr = {tipoqry: `[{$match: {'descrTarea': 'Cambiar aceite', ${argsBuscar}}}, {$sort: {fechaReal: -1}}]`}

      await this.props.allOrdenRtes.refetch(argsBuscarPr)
      let ultimo=''
      if(this.props.allOrdenRtes.allOrdenRtes.length>0){
        if(this.props.allOrdenRtes.allOrdenRtes[0].tipoFrecuencia==='Calendario'){
          ultimo=this.props.allOrdenRtes.allOrdenRtes[0].fechaReal.substring(0, 4) + '-' + this.props.allOrdenRtes.allOrdenRtes[0].fechaReal.substring(5, 7) + '-' + this.props.allOrdenRtes.allOrdenRtes[0].fechaReal.substring(8, 10)
        }else{
          ultimo=this.props.allOrdenRtes.allOrdenRtes[0].acumReal
        }
      }
console.log(args)
      let argsAdd = {
        estadoInflab: 'NUEVO',
        mecInflab: 1,
        ruta: 0,
        numeroOrden: 0,
        ordenSAP: '',
        descrEmpresa: elemento.descrEmpresa,
        nombreUsuario: args.nombreUsuario?args.nombreUsuario:"",
        prioridad: args.prioridad?args.prioridad:"Normal",
        email: args.email?args.email:"",
        telefono: args.telefono?args.telefono:"",
        codPlanta: elemento.codPlanta,
        descrPlanta: elemento.descrPlanta,
        codSeccion: elemento.codSeccion,
        descrSeccion: elemento.descrSeccion,
        codEquipo: elemento.codEquipo,
        descrEquipo: elemento.descrEquipo,
        descrPrograma: elemento.descrPrograma?elemento.descrPrograma:'Sin programa',
        codComponente: elemento.codComponente,
        descrComponente: elemento.descrComponente,
        codMecanismo: elemento.codMecanismo,
        descrMecanismo: elemento.descrMecanismo,
        descrAplicacion: elemento.descrAplicacion,
        descrFabricante: elemento.descrFabricante,
        descrLubricante: elemento.descrLubricante,
        tipoGrado: elemento.tipoGrado,
        descrGrado: elemento.descrGrado,
        tipoFrecuencia: elemento.tipoFrecuencia,
        abrevUnidadTF: elemento.abrevUnidadTF,
        abrevUnidad: elemento.abrevUnidad,
        aceiteRep: 0,
        aceiteTotal: elemento.cantidadTotal,
        fechaMuestra: '',
        tomaMuestra: '',
        ultimoCambio: ultimo,
        cambioFiltroAc: 'No',
        cambioFiltroAire: 'No',
        estadoEnvio: 'Sin enviar',
        fechaCreate: fechaHoraHoy,
        usuarioCreate: localStorage.getItem('userLogin'),
      }
      creaColecc.push(argsAdd)
console.log(creaColecc)
  //GRABAR EN BD
      let numDocCRUD = 0
      let totDocCRUD = 2
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.createInflab)
      }

      argsCrud[numDocCRUD] = creaColecc[0] 
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createInflab

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion

      await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      
      argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
      if(this.props.argsBuscInf.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
      }
      if(this.props.argsBuscInf.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
      }
      if(this.props.argsBuscInf.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
      }
      if(this.props.argsBuscInf.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
      }
      if(this.props.argsBuscInf.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
      }
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'tipoLub': 'Aceite', 'enInfLabNuevo': false, ${argsBuscar}}}]`}
// console.log(argsBuscarPl)
      await this.props.allPlantaRtes1.refetch(argsBuscarPl)




      // await this.props.allPlantaRtes1.refetch()
      await this.props.allInflabRtes.refetch()
    }
    if(accion==="Quitar"){
      let delColecc = [], actColecc = []

      let argsDel = {
        _id: elemento._id
      }
      delColecc.push(argsDel)

      let argsUpd = {
        "descrEmpresa": elemento.descrEmpresa,
        "descrPlanta": elemento.descrPlanta,
        "tipoAct": "EditarInflab",
        "descrSeccion": elemento.descrSeccion,
        "descrEquipo": elemento.descrEquipo,
        "descrComponente": elemento.descrComponente,
        "descrMecanismo": elemento.descrMecanismo,
        "enInfLabNuevo": false,
      }
      // console.log(argsUpd)
      actColecc.push(argsUpd)

  //GRABAR EN BD
      let numDocCRUD = 0
      let totDocCRUD = 2
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.deleteInflab)
      }

      argsCrud[numDocCRUD] = actColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion

      numDocCRUD += 1

      argsCrud[numDocCRUD] = delColecc[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.deleteInflab
// console.log(crudColecc)
console.log(argsCrud)
// console.log(totDocCRUD)
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)
console.log(argsCrud) 
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
      if(this.props.argsBuscInf.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
      }
      if(this.props.argsBuscInf.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
      }
      if(this.props.argsBuscInf.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
      }
      if(this.props.argsBuscInf.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
      }
      if(this.props.argsBuscInf.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
      }
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'tipoLub': 'Aceite', 'enInfLabNuevo': false, ${argsBuscar}}}]`}
console.log(argsBuscarPl)
      this.props.allPlantaRtes1.refetch(argsBuscarPl)





  // this.handleSubmit(ev, this.state.opciones)
      // await this.props.allPlantaRtes1.refetch()
      await this.props.allInflabRtes.refetch()
    }
    document.body.style.cursor = 'default'
  }

  handleSubmit = async (ev, list1)=>{

    if(list1.length>0){
      document.body.style.cursor = 'wait'
      let list = list1
      let addColeccVR = []

console.log(list)
      let numeroInflab = await this.nextVal('inflab')
      for(let ii=0; ii<list.length; ii++){
      // await list1.forEach(async (elemento, ii) => {

        let allPruebasLab = []
        let argsBuscarP = `'descrAplicacion': '${list[ii].descrAplicacion}'`
        let argsBuscPru = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscarP}}}]`}
        let {data} = await this.props.allPruebaRtes.refetch(argsBuscPru)
        allPruebasLab = await data.allPruebaRtes
        const response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = await response.data.fecha
        let actColecc = [], creaColecc = []        
        let movColecc = []

        let argsUpd = {
          "descrEmpresa": list[ii].descrEmpresa,
          "descrPlanta": list[ii].descrPlanta,
          "tipoAct": "EditarInflab",
          "descrSeccion": list[ii].descrSeccion,
          "descrEquipo": list[ii].descrEquipo,
          "descrComponente": list[ii].descrComponente,
          "descrMecanismo": list[ii].descrMecanismo,
          "enInfLabNuevo": false,
        }
        actColecc.push(argsUpd)

        let mecInflab = await this.nextVal('mecInflab')
        list[ii].mecInflab = mecInflab
 
        argsUpd = {
          "_id": list[ii]._id,
          "tipoAct": 'EditarInf',
          "estadoInflab": 'GENERADO',
          "numeroInflab": numeroInflab,
          "mecInflab": mecInflab,
        }
        movColecc.push(argsUpd)
        console.log(actColecc)
        console.log(movColecc)
        let numDocCRUD = 0
        let totDocCRUD = 2
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editInflab)
        }

        argsCrud[numDocCRUD] = actColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion

        numDocCRUD += 1

        argsCrud[numDocCRUD] = movColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editInflab
console.log(argsCrud)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
console.log("PASO 2")


// if(1>2){
  let argsBuscar=""
  argsBuscar += `'descrEmpresa': '${list[ii].descrEmpresa}'`
  argsBuscar += `, 'descrPlanta': '${list[ii].descrPlanta}'`
  argsBuscar += `, 'descrSeccion': '${list[ii].descrSeccion}'`
  argsBuscar += `, 'descrEquipo': '${list[ii].descrEquipo}'`
  argsBuscar += `, 'descrComponente': '${list[ii].descrComponente}'`
  argsBuscar += `, 'descrMecanismo': '${list[ii].descrMecanismo}'`
  argsBuscar += `, 'descrAplicacion': '${list[ii].descrAplicacion}'`
  let argsBuscarVR = {tipoqry: `[{$match: {${argsBuscar}}}]`}
  let regExisteMec = [], regExiste = 0

  console.log(argsBuscarVR)
  if(this.props.allMecValRefRtes.allMecValRefRtes){
    let {data} = await this.props.allMecValRefRtes.refetch(argsBuscarVR)
    regExisteMec = await data.allMecValRefRtes
    if(regExisteMec.length>0){
      regExiste = 1
    }
  }
console.log(regExiste, allPruebasLab.length)
  if(regExiste===0 && allPruebasLab.length>0){
console.log("PASO 3")

    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = await response.data.fecha
    let argsAdd = {
      descrEmpresa: list[ii].descrEmpresa,
      descrPlanta: list[ii].descrPlanta,
      descrSeccion: list[ii].descrSeccion,
      descrEquipo: list[ii].descrEquipo,
      descrComponente: list[ii].descrComponente,
      descrMecanismo: list[ii].descrMecanismo,
      descrAplicacion: list[ii].descrAplicacion,
      fechaCreate: fechaHoraHoy,
      usuarioCreate: localStorage.getItem('userLogin'),
    }
    creaColecc.push(argsAdd)

    let numDocCRUD = 0
    let totDocCRUD = 1
    let argsCrud = []
    let crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.createMecValRef)
    }

    argsCrud[numDocCRUD] = creaColecc[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.createMecValRef

    await this.updColecc(crudColecc, argsCrud, totDocCRUD)


console.log("PASO 4")

    let argsVR = {}

    argsVR = {
        "descrEmpresa": list[ii].descrEmpresa,
        "descrPlanta": list[ii].descrPlanta,
        "descrSeccion": list[ii].descrSeccion,
        "descrEquipo": list[ii].descrEquipo,
        "descrComponente": list[ii].descrComponente,
        "descrMecanismo": list[ii].descrMecanismo,
        "descrAplicacion": list[ii].descrAplicacion,
      }
      let addColeccPru1 = []                
      for (let i=0;i<allPruebasLab.length;i++){
        if(allPruebasLab[i].tipoPrueba!=='Pruebas especiales'){
          let addColeccPru = {
            "descrPrueba": allPruebasLab[i].descrPrueba,
            "tipoPrueba": allPruebasLab[i].tipoPrueba,
            "validacion": allPruebasLab[i].validacion,
            "valor1Alarma": allPruebasLab[i].valor1Alarma,
            "valor2Alarma": allPruebasLab[i].valor2Alarma,
            "valor3Alarma": allPruebasLab[i].valor3Alarma,
            "valor1Corte": allPruebasLab[i].valor1Corte,
            "valor2Corte": allPruebasLab[i].valor2Corte,
            "valor3Corte": allPruebasLab[i].valor3Corte,
          }
          addColeccPru1.push(addColeccPru)
        }
      }
      argsVR['pruebaslab'] = addColeccPru1
      addColeccVR.push(argsVR)
      addColeccPru1 = {}
      argsVR = {}

    await this.props.allMecValRefRtes.refetch()  
    await this.props.allPruebaRtes.refetch()  
  }
// }

        if(ii===list1.length-1){
          let addColeccVR1 = []
console.log("PASO 8")
// if(1>2){
          addColeccVR1.push({mecvalref: addColeccVR})
console.log(addColeccVR1)
          let numDocCRUD = 0
          let totDocCRUD = 1
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editMecValRefVR)
          }

          argsCrud[numDocCRUD] = addColeccVR1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editMecValRefVR
        console.log(argsCrud)
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)

console.log("PASO 9") 
// }         
//Archivo Excel
          let xlsString = []
          let listRtes = list
// console.log(listRtes)
          let xlsString1 = []
          xlsString1 = ['Código informe', 'Ruta', 'OT', 'OT SAP', 'Orden de compra', 'Empresa', 'Planta', 'Sección', 'Equipo', 'Código equipo', 'Componente',
            'Mecanismo', 'Aplicación', 'Estado', 'Fabricante del aceite', 'Nombre del aceite', 'Grado', 'Fecha de muestra', 'Toma de muestra del aceite',
            'Ultimo cambio de aceite', 'Recorrido del aceite', 'Tipo de frecuencia', 'Cambio del filtro de aceite',
            'Cambio del filtro de aire', 'Volumen de aceite de reposición',
            'Volumen de cambio de aceite', 'Unidad de volumen del lubricante', 'Viscosidad, cSt a 40ºC',
            'Viscosidad, cSt a 100ºC', 'Indice de Viscosidad IV', 'Agua', 'Codigo de particulas', 'Particulas > 4 micras',
            'Particulas > 6 micras', 'Particulas > 14 micras', 'Particulas > 21 micras', 'Particulas > 25 micras',
            'Particulas > 38 micras', 'Particulas > 70 micras','Hollin', 'Nitracion', 'Sulfatacion', 
            'Dilución por Combustible', 'Glicol', 'Oxidacion', 'TAN', 'TBN', 'Hierro (Fe)', 'Cobre (Cu)', 'Aluminio (Al)',
            'Cromo (Cr)', 'Plomo (Pb)', 'Estaño (Sn)', 'Niquel (Ni)', 'Vanadio (V)', 'Titanio (Ti)', 'Silicio (Si)',
            'Sodio (Na)', 'Potasio (K)', 'Boro (B)', 'Magnesio (Mg)', 'Calcio (Ca)', 'Fosforo (P)', 'Zinc (Zn)',
            'Molibdeno (Mo)', 'Bario (Ba)', 'Manganeso (Mn)', 'Color', 'Ruler %', 'Aminas', 'Fenoles', 'ZDDP', 'RPVOT', 
            'Barnices', 'Dem. aceite', 'Dem. agua', 'Dem. emulsión', 'Dem. tiempo', 'Espumas I 0', 'Espumas I 10', 
            'Espumas II 0', 'Espumas II 10', 'Espumas III 0', 'Espumas III 10', 
            'Lib. aire', 'Punto inf.', 'Corrosión', 'Ultracentrifuga', 'Densidad a 15°C', 'Apariencia', 'Olor', 'Punto de fuego', 
            'Indice PQ', 'Fischer', 'TAN con PTE', 'TBN con PTE', 'Prioridad', 'Análisis', 'Acciones', 'Observaciones del laboratorio']
          xlsString.push(xlsString1)

          for(let i=0; i<listRtes.length; i++){
            xlsString1 = [listRtes[i].mecInflab, listRtes[i].ruta, listRtes[i].numeroOrden, '', '',
              listRtes[i].descrEmpresa, listRtes[i].descrPlanta,
              listRtes[i].descrSeccion, listRtes[i].descrEquipo, listRtes[i].codEquipo, listRtes[i].descrComponente,
              listRtes[i].descrMecanismo, listRtes[i].descrAplicacion, '', listRtes[i].descrFabricante,
              listRtes[i].descrLubricante, listRtes[i].tipoGrado, '', '', listRtes[i].ultimoCambio, '', 
              listRtes[i].tipoFrecuencia, listRtes[i].cambioFiltroAc, listRtes[i].cambioFiltroAire, '', listRtes[i].aceiteTotal,
              listRtes[i].abrevUnidad, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 
              '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 
              '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 
              '', '', '', '', listRtes[i].prioridad, '', '', '']

// console.log(xlsString1)
            xlsString.push(xlsString1)
          }
// console.log(xlsString)

          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Inflab");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Inflab"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'informe_'+numeroInflab+'.xlsx');
//FIN Exportar a XLS
console.log("PASO 9")
        }

        await this.props.allPlantaRtes1.refetch()
        await this.props.allInflabRtes.refetch()  
      // })
      }
      document.body.style.cursor = 'default'
      this.setState({open: false, confirmaAct: false})
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidUpdate = async (prevProps) => {    
    if(this.props.argsBuscInf!==this.state.argsBuscInf){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
      if(this.props.argsBuscInf.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
      }
      if(this.props.argsBuscInf.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
      }
      if(this.props.argsBuscInf.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
      }
      if(this.props.argsBuscInf.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
      }
      if(this.props.argsBuscInf.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
      }

      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'tipoLub': 'Aceite', 'enInfLabNuevo': false, ${argsBuscar}}}]`}

      await this.props.allPlantaRtes1.refetch(argsBuscarPl)
      
      if(this.props.allPlantaRtes1.allPlantaRtes){
        this.setState({argsBuscInf: this.props.argsBuscInf})
        if(this.props.allPlantaRtes1.allPlantaRtes&&prevProps.allPlantaRtes1.allPlantaRtes){
          if((this.props.allPlantaRtes1.allPlantaRtes!==prevProps.allPlantaRtes1.allPlantaRtes)||!this.state.list){
            this.setState({list: 
              this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes.map((elemento, i) => ({
                ...elemento
              })):[]
            })
          }
        }
      }
      // this.setState({list});
      this.setState({argsBuscInf: this.props.argsBuscInf})

      // if(this.props.allPlantaRtes1.allPlantaRtes){
      //   this.setState({argsBuscInf: this.props.argsBuscInf})
      //   this.setState({list: this.props.allPlantaRtes1.allPlantaRtes})
      // }
    }
  }

  render(){
    const {argsDocum, permiteUpdate, confirmaAct, open, list} = this.state;

    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Generar informe"
    let imgIcon = "images/documento_32.png"

    let listMec = [], list1 = [], list2 = []
    // if(this.props.allPlantaRtes1.allPlantaRtes){list = this.props.allPlantaRtes1.allPlantaRtes}
    if(list){listMec = list}

    if(this.props.allInflabRtes.allInflabRtes){list1 = this.props.allInflabRtes.allInflabRtes}
    
    // if(this.props.allEmpresa.allEmpresa){list2 = this.props.allEmpresa.allEmpresa}
// console.log(list)

    let listCon=[]
    if (argsDocum.descrEmpresa){
      let empre=argsDocum.descrEmpresa
      if(this.props.allUsuarios.allUsuarios){
        list2 = this.props.allUsuarios.allUsuarios
        listCon = list2.filter(elemento => elemento.descrEmpresa===empre && elemento.tipo==='Externo')
      }
    } 

    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list1):()=>{}}>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '25%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={this.props.list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaCon styles={this.props.styles} list={listCon} handleChange={this.handleChange} />
                  </Form.Field>                
                </div>
                <div className="column" style={{width: '25%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    {/* <label style={this.props.styles.label}>Prioridad</label> */}
                    <ListaPri styles={this.props.styles} handleChange={this.handleChange} />
                  </Form.Field>                
                </div>
                <div className="column" style={{width: '25%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>

            {/* <hr></hr> */}

            <div>
              <div style={{height: '20em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cód equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Tipo Frec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Informe</th>
                    </tr>
                  </thead>
                  <ListaPl list={listMec} handleClickGesEgr={this.handleClickGesEgr} argsDocum={argsDocum}/>
                </table>
                <p></p>
              </div>
            </div>

            <hr></hr>

            <div>
              <div style={{height: '15em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cód equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Tipo Frec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Quitar</th>
                    </tr>
                  </thead>
                  <ListaIL list={list1} handleClickGesEgr={this.handleClickGesEgr}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrTarea: 'Cambiar aceite'}}]`}}}}),
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estadoInflab: 'NUEVO', usuarioCreate: '${props.usuario}'}}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),


  graphql(queries.mutation.createInflab, {name:'createInflab'}),
  graphql(queries.mutation.deleteInflab, {name:'deleteInflab'}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),

  graphql(queries.mutation.editInflab, {name:'editInflab'}),

  graphql(queries.query.allPrueba, {name:'allPrueba'}),

  graphql(queries.query.allPruebaRtes, {name:'allPruebaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'descrPrueba': {$ne: 'XXX'}}}]`}}}}),

  graphql(queries.query.allMecValRefRtes, {name:'allMecValRefRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: {$ne: 'XXX'}}}]`}}}}),
  graphql(queries.query.allMecValRefRtes, {name:'allMecValRefRtesUlt',
  options: (props) => {return {variables: {tipoqry: `[{$group: {_id: 1, ultimo: { $last: '$_id' }}},
  {$project: {_id: 0, ultimo: '$ultimo'}}]`}}}}),

  graphql(queries.mutation.createMecValRef, {name:'createMecValRef'}),
  graphql(queries.mutation.editMecValRef, {name:'editMecValRef'}),
  graphql(queries.mutation.editMecValRefVR, {name:'editMecValRefVR'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(LabInflab2)
